import { useState, useRef } from 'react';
import { dailyContestArticles } from '@/mocks/articles';
import SectionTitle from '@/components/base/SectionTitle';

export default function DailyContest() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [voted, setVoted] = useState<Record<string, boolean>>({});

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = 300;
      scrollRef.current.scrollBy({ left: direction === 'left' ? -amount : amount, behavior: 'smooth' });
    }
  };

  const handleVote = (id: string) => {
    setVoted((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionTitle
          title="网红爆料"
          highlight="每日大赛"
          subtitle="参与投票，选出你心中的年度之最"
          rightTag="查看更多 ▸"
          rightLink="/category/meiri-dasai"
        />

        {/* Scrollable Cards */}
        <div className="relative">
          <button
            onClick={() => scroll('left')}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:bg-background-200 shadow-sm transition-colors cursor-pointer -ml-5"
          >
            <i className="ri-arrow-left-s-line"></i>
          </button>

          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide"
            style={{ scrollSnapType: 'x mandatory' }}
          >
            {dailyContestArticles.map((item) => (
              <div
                key={item.id}
                className="flex-shrink-0 w-[240px] md:w-[280px] rounded-xl overflow-hidden bg-background-50 transition-all duration-300"
                style={{ scrollSnapAlign: 'start' }}
              >
                <div className="relative w-full h-40 overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-medium text-foreground-900 line-clamp-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">{item.excerpt}</p>
                  <div className="flex items-center justify-between mt-4">
                    <span className="text-lg font-heading text-foreground-900">
                      {voted[item.id] ? (item.votes + 1).toLocaleString() : item.votes.toLocaleString()}
                      <span className="text-xs text-foreground-500 font-sans ml-1">票</span>
                    </span>
                    <button
                      onClick={() => handleVote(item.id)}
                      className={`px-4 py-2 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                        voted[item.id]
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700'
                      }`}
                    >
                      {voted[item.id] ? '已投票' : '投票'}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={() => scroll('right')}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:bg-background-200 shadow-sm transition-colors cursor-pointer -mr-5"
          >
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}